import { createWebHistory, createRouter } from "vue-router";
import memberSubscribe from "./view/memberSubscribe.vue"
import welcomePage from "./view/welcomePage.vue"
import loginPage from "./view/loginPage.vue"
import Home from "./view/homePage.vue"
import afterLoginPage from "./view/afterLogin.vue"
import writeContent from "./components/writeContent.vue"
import listCom from "./components/listCom.vue";
import store from "./store.js"

const routes = [
    {
        path: "/",
        component: Home,
        beforeEnter: () => {
            // 이미 로그인된 상태면 대시보드로 리다이렉트
            if (store.state.isLogin) {
                return { path: '/afterLoginPage' };
            }
        }
    },
    {
        path: "/memberdescribe",
        component: memberSubscribe
    },
    {
        path: "/welcomePage",
        component: welcomePage
    },
    {
        path: "/loginPage",
        component: loginPage,
        beforeEnter: () => {
            // 이미 로그인된 상태면 대시보드로 리다이렉트
            if (store.state.isLogin) {
                return { path: '/afterLoginPage' };
            }
        }
    },
    {
        path: "/afterLoginPage",
        component: afterLoginPage,
        meta: { requiresAuth: true }
    },
    {
        path: "/writeContent",
        component: writeContent,
        meta: { requiresAuth: true },
    },
    {
        path: "/listCom",
        component: listCom,
        meta: { requiresAuth: true },
    },
];

const router = createRouter({
    history: createWebHistory(),
    routes,
});

/**
 * 전역 네비게이션 가드
 * - requiresAuth 라우트에 대해서만 로그인 상태 확인
 * - 이미 로그인 상태면 loginCheck 생략 (불필요한 API 호출 방지)
 * - 미로그인이고 accessToken 이 있으면 loginCheck 로 검증
 * - 그래도 미로그인이면 /loginPage 로 리다이렉트
 */
router.beforeEach(async (to) => {
    if (!to.meta.requiresAuth) return true;

    // 이미 로그인 상태면 통과
    if (store.state.isLogin) return true;

    // accessToken 이 있으면 서버 검증 시도
    const at = localStorage.getItem('accessToken');
    if (at) {
        await store.dispatch('loginCheck');
    }

    // 그래도 미로그인이면 로그인 페이지로
    if (!store.state.isLogin) {
        return { path: '/loginPage', query: { to: to.path } };
    }

    return true;
});

export default router;
